import { HeroBannerContainter, Heading, SubHeading, SupportingText } from './hero-banner-styles'

type HeroBannerProps = {
  heading: string
  subHeading: string
  supportingText: string
}

const HeroBanner = ({ heading, subHeading, supportingText }: HeroBannerProps) => (
  <HeroBannerContainter>
    <SubHeading>{subHeading}</SubHeading>
    <Heading>{heading}</Heading>
    <SupportingText>{supportingText}</SupportingText>
  </HeroBannerContainter>
)
export default HeroBanner
